import { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ViewerManagerUpdateStatusApi } from './viewerManagerUpdateStatusApi'
import { fetchRequestsDataRequirementsChecker } from './fetchRequestsDataRequirementsChecker'
import { ViewerManagerApiImplementor } from 'thunderbolt-viewer-manager-types'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { DataRequirementsCheckerSymbol, DebugDataRequirementsCheckersSymbol } from '@wix/thunderbolt-symbols'

export const editor: ContainerModuleLoader = (bind) => {
	bind(ViewerManagerApiImplementor, DebugDataRequirementsCheckersSymbol).to(ViewerManagerUpdateStatusApi)

	// Implements check for pending fetch requests
	bind(ModelUpdatesHandlersImplementor, DataRequirementsCheckerSymbol).to(fetchRequestsDataRequirementsChecker)
}
